import { getColorSchemeFromPrimaryColor } from 'mini-color/lib/utils/colorSchemeGenerator';
import type { ThemePalette } from '../schema/MiniPalette';

/**
 * Generates a theme palette based on the given color and whether the theme is dark or not.
 * @param color
 * @param isDarkTheme
 * @returns
 */
export const generateThemePalette = (color: string, isDarkTheme: boolean): ThemePalette => {
    const {
        schemePrimary,
        schemeDarker,
        schemeDark,
        schemeDarkAlt,
        schemeSecondary,
        schemeTertiary,
        schemeLight,
        schemeLighter,
        schemeLighterAlt,
    } = getColorSchemeFromPrimaryColor(color, isDarkTheme);

    return {
        themeDarker: schemeDarker,
        themeDark: schemeDark,
        themeDarkAlt: schemeDarkAlt,
        themePrimary: schemePrimary,
        themeSecondary: schemeSecondary,
        themeTertiary: schemeTertiary,
        themeLight: schemeLight,
        themeLighter: schemeLighter,
        themeLighterAlt: schemeLighterAlt,
        sidePaneSelectedBackground: isDarkTheme ? '#212121' : schemeLighter,
        headerBackground: isDarkTheme ? '#212121' : schemePrimary,
        headerButtonBackground: isDarkTheme ? '#141414' : schemeDark,
        headerButtonPressedBackground: isDarkTheme ? '#303030' : schemeDark,
        headerSearchBarBackground: isDarkTheme ? '#303030' : schemeDark,
        headerSearchBarButtonPressedBackground: isDarkTheme ? '#212121' : schemeDarker,
        activePillBg: isDarkTheme ? '#404040' : schemePrimary,
        activePillFg: isDarkTheme ? '#ffffff' : '#f8f8f8',
        inactivePillBg: isDarkTheme ? '#141414' : '#f1f1f1',
        inactivePillFg: isDarkTheme ? '#e1e1e1' : '#6e6e6e',
        activePillBgOnThemeBg: isDarkTheme ? '#404040' : '#ffffff',
        activePillFgOnThemeBg: isDarkTheme ? '#ffffff' : schemePrimary,
        inactivePillBgOnThemeBg: isDarkTheme ? '#141414' : schemeDarkAlt,
        inactivePillFgOnThemeBg: isDarkTheme ? '#e1e1e1' : '#ffffff',
        selection: isDarkTheme ? '#206AA1' : schemeLighter,
        toastBg: isDarkTheme ? schemePrimary : '#000000',
    };
};
